import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY




export const getOperadores = async (params = {}) => {
    try { 
       const res = await api.get(`${urlApi}/talentoHumano/operadores`, { params });
       return res.data;
    } catch (error) {
        console.error('Error al obtener los operadores:', error);
        throw error; // Re-lanzar el error para que pueda ser manejado por quien llame a esta función
    }
};

export const getCalificacionBitacoras = async (params = {}) => {
    try { 
       const res = await api.get(`${urlApi}/talentoHumano/calificacion-bitacoras`, { params });
       return res.data;
    } catch (error) {
        console.error('Error al obtener las calificaciones de bitácoras:', error);
        throw error; // Re-lanzar el error para que pueda ser manejado por quien llame a esta función
    }
};
export const getCalificacionOperadorGrafica = async (params = {}) => {
    try { 
       const res = await api.get(`${urlApi}/talentoHumano/calificacion-operador-grafica`, { params });
       return res.data;
    } catch (error) {
        console.error('Error al obtener las calificaciones de operador para la gráfica:', error);
        throw error; // Re-lanzar el error para que pueda ser manejado por quien llame a esta función
    }
};
export const getCalificacionGeneralGrafica = async (params = {}) => {
    try { 
       const res = await api.get(`${urlApi}/talentoHumano/calificacion-grafica-general`, { params });
       return res.data;
    } catch (error) {
        console.error('Error al obtener las calificaciones generales para la gráfica:', error);
        throw error;
    }
};
export const getCalificacionOperadorParametrosGenerales = async (params = {}) => {
    try { 
       const res = await api.get(`${urlApi}/talentoHumano/calificacion-operador-parametros-generales`, { params });
       return res.data;
    } catch (error) {
        console.error('Error al obtener las calificaciones generales para la gráfica:', error);
        throw error;
    }
};
export const getRutasExcluidas = async () => {
    try { 
       const res = await api.get(`${urlApi}/talentoHumano/rutas-excluidas`);
       return res.data;
    } catch (error) {
        console.error('Error al obtener las rutas excluidas:', error);
        throw error;
    }
};
export const getReporteNominal = async (fecha_inicio, fecha_fin) => {
    try { 
       const res = await api.get(`https://rhflex-api.sumaenlinea.mx/rhflex/getBitacorasOperadorReport?fecha_inicio=${fecha_inicio}&fecha_fin=${fecha_fin}`);
       return res.data;
    } catch (error) {
        console.error('Error al obtener las rutas excluidas:', error);
        throw error;
    }
};